import React from 'react';

export default function HeroSliderConfig({ data, onChange }) {
  const slides = data.slides || [];

  const updateSlide = (index, field, value) => {
    const newSlides = [...slides];
    newSlides[index] = { ...newSlides[index], [field]: value };
    onChange({ ...data, slides: newSlides });
  };

  const addSlide = () => {
    onChange({ ...data, slides: [...slides, { image: '', alt: '', tag: '', title: '', description: '', cta: '', ctaLink: '' }] });
  };

  const removeSlide = (index) => {
    onChange({ ...data, slides: slides.filter((_, i) => i !== index) });
  };

  return (
    <>
      <div className="adminblog-field">
        <label>
          <input type="checkbox" checked={data.autoplay || false} onChange={(e) => onChange({ ...data, autoplay: e.target.checked })} style={{ marginRight: 8 }} />
          Autoplay
        </label>
      </div>
      {data.autoplay && (
        <div className="adminblog-field">
          <label>Interval (ms)</label>
          <input type="number" value={data.autoplayDelay || 5000} onChange={(e) => onChange({ ...data, autoplayDelay: parseInt(e.target.value) || 5000 })} placeholder="5000" />
        </div>
      )}
      <div className="adminblog-field">
        <label>Slides ({slides.length})</label>
        {slides.map((slide, i) => (
          <div key={i} className="adminblog-list-item" style={{ flexDirection: 'column', gap: 6, padding: '12px 0', borderBottom: '1px solid #eee' }}>
            <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
              <strong style={{ fontSize: 11, color: '#666' }}>Slide {i + 1}</strong>
              <button className="adminblog-list-remove" onClick={() => removeSlide(i)} style={{ marginLeft: 'auto' }}>×</button>
            </div>
            <input type="text" value={slide.image || ''} onChange={(e) => updateSlide(i, 'image', e.target.value)} placeholder="Image URL" />
            <input type="text" value={slide.alt || ''} onChange={(e) => updateSlide(i, 'alt', e.target.value)} placeholder="Alt text" />
            <input type="text" value={slide.tag || ''} onChange={(e) => updateSlide(i, 'tag', e.target.value)} placeholder="Tag text (small text above title)" />
            <input type="text" value={slide.title || ''} onChange={(e) => updateSlide(i, 'title', e.target.value)} placeholder="Slide title" />
            <textarea value={slide.description || ''} onChange={(e) => updateSlide(i, 'description', e.target.value)} placeholder="Slide description" rows={2} />
            <input type="text" value={slide.cta || ''} onChange={(e) => updateSlide(i, 'cta', e.target.value)} placeholder="Button text" />
            <input type="text" value={slide.ctaLink || ''} onChange={(e) => updateSlide(i, 'ctaLink', e.target.value)} placeholder="Button URL" />
          </div>
        ))}
        {slides.length < 8 && (
          <button className="adminblog-list-add" onClick={addSlide}>+ Add Slide</button>
        )}
      </div>
    </>
  );
}
